import { Model } from "@interfaces/model.interface";

export interface AllocationWorkOrder extends Model {
	allocationId: number;
	quantity: number;
	reportedById: number;
	workOrderId: number;
}

export class AllocationWorkOrder implements AllocationWorkOrder {
	constructor(data?: Partial<AllocationWorkOrder>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}